<template lang="pug">
    .authentication-form
        h2.has-no-margin.is-size-4-desktop.is-size-5-tablet.is-size-6-mobile.has-text-weight-light(v-if="!auth") Bitte melden Sie sich an, um Ihren Account zu bestätigen!
        Authenticate(
            defaultTab="signin"
            :registration="false"
            @success="verifyEmail"
        )
            transition(name="slide-vertical")
                .notification.is-danger.is-light(v-if="error")
                    button.delete(
                        type="button"
                        @click="error = false"
                    )
                    | {{ error }}
            .notification.is-info.is-light(v-if="verification.success")
                button.delete(
                    type="button"
                    @click="verification.success = false; tab = 'signin'"
                )
                | {{ verification.success }}
</template>

<script>

import Vue from 'vue';
import store from '@/store'

import { mapGetters } from 'vuex'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Authenticate from '@/components/Authenticate'

import Loading from 'vue-loading-overlay'

import { translateWarnings, translateSuggestion } from '@/validation';

let timeout;
export default {
    name: 'EmailVerificationForm',
    data() {
        let data = {
            error: false,
            loading: false,
            verification: {
                type: 'verification',
                warning: false,
                success: false,
            },
        }

        return data
    },
    components: {
        Loading,
        ValidationObserver,
        ValidationProvider,
        Authenticate,
    },
    computed: {
        hash() {
            return this.$route.params.hash
        },
        signature() {
            return this.$route.params.signature
        },
        expires() {
            return this.$route.params.expires
        },
        id() {
            return this.$route.params.id
        },
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            cms: 'CMS',
            auth: 'auth/isAuthenticated',
            token: 'auth/token'
        }),
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, { siteKey: this.recaptchaSiteKey })
        }
    },
    mounted() {
        if(this.auth){
            this.verifyEmail()
        }
    },
    methods: {
        verifyEmail() {
            console.log('test')
            this.error = false
            this.loading = true
            if (timeout) clearTimeout(timeout)
            try {
                const payload = {
                    hash: this.hash, //email hash
                    token: this.token, // jwt
                    id: this.id,
                    signature: this.signature,
                    expires: this.expires,
                    token: this.token
                }
                store.dispatch('auth/verifyEmail', payload)
                    .then(data => {
                        this.verification.success = 'Ihr Account wurde freigeschaltet. Sie können sich jetzt mit Ihren Zugangsdaten anmelden.'
                    })
                    .catch(error => {
                        this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                        timeout = setTimeout(() => this.error = false, 6000)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            } catch (error) {
                console.error(error);
                this.error = 'Es gibt ein technisches Problem. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
                timeout = setTimeout(() => this.error = false, 6000)
                this.loading = false
            }
        }
    }
}

</script>

<style lang="sass" scoped>
    .authentication-form
        padding-top: 0
    h2
        padding-top: 4.5rem
</style>
